import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ReactSVG } from 'react-svg';
import { IconSvg } from '../../../../../utils/globalIcons';
import { getStyles } from './styles';
import AnalyticsApi from '../../../../../Api/Services/AmeyaBackend/AnalyticsToolApi';
import LoadBar from '../../../../../utils/LoadBar';
import { tostAlert } from '../../../../../utils/AlertToast';
import { formatLabel } from '../../../../../utils';

function MongoDB({ setMongodbData, mongodbData }) {

    const theme = useTheme();
    const styles = getStyles(theme);

    const handleTestConnection = async () => {
        setMongodbData(prev => ({ ...prev, loading: true }));
        try {
            setMongodbData(prev => ({ ...prev, connectionStatus: "" }));
            const reqObj = { uri: mongodbData.connectionMongoUri };
            const response = await AnalyticsApi.mongoConnectionDBLists(JSON.stringify(reqObj));

            if (response.status === 200) {
                setMongodbData(prev => ({ ...prev, connectionStatus: "success" }));
            } else {
                setMongodbData(prev => ({ ...prev, connectionStatus: "failed" }));
            }

        } catch (error) {
            console.log(error);
            setMongodbData(prev => ({ ...prev, connectionStatus: "failed" }));
            tostAlert('Connection Failed Try Again', 'error');
        } finally {
            setMongodbData(prev => ({ ...prev, loading: false }));
        }
    }

    return (
        <Box>

            {mongodbData.loading && <LoadBar />}

            <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>Connection Name</Typography>
            <Typography sx={{ fontSize: '14px', fontWeight: '600', marginTop: '10px' }}>{(formatLabel(mongodbData.connectionName))}</Typography>

            <Box marginTop={'20px'}>
                <Typography mb={1}>Connection String</Typography>
                <TextField
                    variant="outlined"
                    type="text"
                    size='medium'
                    disabled
                    sx={{ width: '600px' }}
                    value={mongodbData.connectionMongoUri}
                />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: '50px', marginTop: '10px' }}>

                <Typography
                    onClick={handleTestConnection}
                    sx={{
                        fontSize: '14px', fontWeight: '600', color: '#0B51C5', cursor: 'pointer',
                        '&:hover': { textDecoration: 'underline' }
                    }}
                >
                    TEST CONNECTION
                </Typography>
                {mongodbData.connectionStatus === "success" &&
                    <Box display={'flex'} alignItems={'center'} flexDirection={'row'} gap={'7px'}>
                        <ReactSVG
                            src={IconSvg.plugConnectedIcon}
                            beforeInjection={(svg) => {
                                svg.setAttribute('style', 'width:24px; height:24px; display:block;');
                                svg.setAttribute('stroke', '#1BA559');
                            }}
                        />
                        <Typography sx={styles.paraText}>Connection successful</Typography>
                    </Box>
                }

                {mongodbData.connectionStatus === "failed" &&
                    <Box display={'flex'} alignItems={'center'} flexDirection={'row'} gap={'7px'}>
                        <ReactSVG
                            src={IconSvg.plugNotConnectedIcon}
                            beforeInjection={(svg) => {
                                svg.setAttribute('style', 'width:24px; height:24px; display:block;');
                                svg.setAttribute('stroke', '#E00000');
                            }}
                        />
                        <Typography sx={styles.paraText}>Unable to connect</Typography>
                    </Box>
                }
            </Box>

        </Box>
    )
}

export default MongoDB;